// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1339": "cea6d275e83a","2898": "67f618600057","5336": "5083bc5218c4","5809": "6c631c5dc875","6563": "c118f70d3cdb","824": "4b8094718b50","888": "8cf3ee70ad96","927": "f921d25b46de",}[chunkId] + ".css"
}